import reducer from "./reducer";
export { default as TypesOfOnboardingActions } from "./components/index";
export { default as typesOfOnboardingActionsReducerName } from "./constants";
export default reducer;
